import { UrlFormatter } from 'shared';

/**
 * Byte-identical port of the AngularJS `ftAzureStoredPhoto` filter
 * (account-v1/src/components/common/images/images.js). Builds the Azure CDN URL for a
 * photo object: extracts the UUID from the first present of
 * `@imageUUID`/`imageUUID`/`@photoUUID`/`photoUUID`/`id`/`uuid` (else the value itself),
 * lowercases it, and composes `<AzureCdnBaseUrl>[/]public/<uuid>[-<size>].jpg` via the
 * native `UrlFormatter.format` (the same `:token` replace the v1 `urlFormatter` used, #26).
 *
 * Takes `azureCdnBaseUrl` as a param (instead of injecting the AngularJS `environment`) so
 * native consumers can drop the `$filter('ftAzureStoredPhoto')` bridge while
 * staying character-for-character identical to the frozen v1 baseline. The output is an
 * image URL (gate-blind) → proven by account-parity/_diag-azure-photo-check.mjs (0/96).
 */
export function buildAzureStoredPhotoUrl(
  photo: any,
  size: string | null | undefined,
  azureCdnBaseUrl: string
): string | null {
  if (!photo) return null;
  const photoUUID =
    photo['@imageUUID'] || photo['imageUUID'] || photo['@photoUUID'] || photo['photoUUID'] || photo['id'] || photo['uuid'] || photo;
  if (!photoUUID) return null;
  const hasTrailingSlash = azureCdnBaseUrl.lastIndexOf('/') === azureCdnBaseUrl.length - 1;
  const path = UrlFormatter.format('public/:photoId:size.jpg', {
    photoId: photoUUID.toLowerCase(),
    size: size ? '-' + size : '',
  });
  return azureCdnBaseUrl + (hasTrailingSlash ? '' : '/') + path;
}
